import { Submultiples } from "../../SIprefixe";
import { Unit, UnitBaseTypes } from "../../Units";

function MillimetreSquared() {
  return <Unit unit={UnitBaseTypes.metre} prefix={Submultiples.milli} exponent={2} />;
}

export default MillimetreSquared;
